import { SvgIcon } from '@mui/material';

const NonFoodIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5 6.5h6a2 2 0 0 1 2 2v5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-5a2 2 0 0 1 2-2m0 0v-1A1.494 1.494 0 0 1 6.5 4h3A1.494 1.494 0 0 1 11 5.5v1m.5-4a1 1 0 0 0-1-1h-4m1.5 0V4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default NonFoodIcon;
